$(document).off("click", ".js-add-to-cart").on("click", ".js-add-to-cart", function () {
    const $btn = $(this)
    if ($btn.data('loading')) return // 防止重复点击
    $btn.data('loading', true)

    const variantId = $btn.data("variant-id")
    if (!variantId) return

    const cartDrawer = document.querySelector('cart-drawer')
    if (!cartDrawer) {
        console.error('找不到 cart-drawer 元素')
        return
    }

    // 获取需要更新的 sections
    const sections = cartDrawer.getSectionsToRender()

    // 只发一次 fetch 请求
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new URLSearchParams({
            id: variantId,
            quantity: 1,
            sections: sections.map(s => s.id),
            sections_url: window.location.pathname
        })
    })
        .then(res => res.json())
        .then(response => {
            // 更新侧拉购物车内容
            cartDrawer.renderContents(response)
            cartDrawer.classList.add('active')
        })
        .catch(err => console.error('加入购物车失败', err))
        .finally(() => {
            $btn.data('loading', false)
        })
})

//页面对比功能
const MAX_COMPARE = 3
const compareBar = document.querySelector('.compare-bar')
const checkboxes = document.querySelectorAll('.compare-checkbox')
const clearBtns = document.querySelectorAll('.clear-all')
const startBtn = document.querySelector('.start-comparison')

let selectedProducts = []

/**
 * 更新 Compare Bar UI
 */
function updateCompareBar () {
    document.querySelectorAll('.compare-count').forEach(el => {
        el.textContent = `${selectedProducts.length} Selected`
    })

    if (selectedProducts.length > 0) {
        compareBar.style.display = 'block'
    } else {
        compareBar.style.display = 'none'
    }
}

/**
 * Checkbox 逻辑
 */
checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
        const productId = this.getAttribute('data-product-id')

        if (this.checked) {
            if (selectedProducts.length >= MAX_COMPARE) {
                alert('You can only select up to 3 products.')
                this.checked = false
                return
            }
            selectedProducts.push(productId)
        } else {
            selectedProducts = selectedProducts.filter(id => id !== productId)
        }

        updateCompareBar()
    })
})

/**
 * Clear All
 */
clearBtns.forEach(btn => {
    btn.addEventListener('click', function () {
        selectedProducts = []

        checkboxes.forEach(cb => {
            cb.checked = false
        })

        // 清除 URL 参数（不刷新）
        const url = new URL(window.location.href)
        url.searchParams.delete('vids')
        history.replaceState({}, '', url)

        updateCompareBar()
    })
})

/**
 * Start Comparison
 */
if (startBtn) {
    startBtn.addEventListener('click', function () {
        if (selectedProducts.length === 0) return

        const vids = selectedProducts.join(',')
        window.location.href = `/pages/compare-the-models/${vids}`
    })
}


window.addEventListener('load', function () {
    updateCompareBar()
})

/**
 *  如果是浏览器后退 / 前进（bfcache）兼容并重置
 */
window.addEventListener('pageshow', function () {
    requestAnimationFrame(resetCompareState)
})
function resetCompareState () {
    selectedProducts = []

    document.querySelectorAll('.compare-checkbox').forEach(cb => {
        cb.checked = false
    })

    updateCompareBar()
}


